import { ITcc } from "../types/data.interface";

export const formatTccIntoOption = (item: ITcc) => ({
  value: item,
  label: `${getTccDisplayCode(item)} - ${item.name}`,
});

export const formatTccIntoOptionLegacy = (item: ITcc) => ({
  value: item,
  label: `${getTccCode(item)} - ${item.name}`,
});

export const getTccCode = (tcc: ITcc) => {
  if (!!tcc){
    return tcc?.suffix ? `${tcc?.global_product?.sub_category?.parent?.code}${tcc?.global_product?.sub_category.code}${tcc?.global_product?.product_line.code}${tcc?.global_product?.suffix}-${tcc?.suffix}`:`${tcc?.global_product?.sub_category?.parent?.code}${tcc?.global_product?.sub_category.code}${tcc?.global_product?.product_line.code}${tcc?.global_product?.suffix}`;
  }
};

export const getTccDisplayCode = (tcc: ITcc) => {
  if (tcc.itn_itemno != null && tcc.itn_itemno !== 0) {
    return tcc.itn_itemno.toString();
  }

  return getTccCode(tcc);
};


export const getTcc = (tccs: ITcc[]) => tccs.map(formatTccIntoOption);

export const getItemNumberDisplayCode = (itemNumber: ITcc) => {
  if(itemNumber) {
    return itemNumber?.itn_itemno || getTccCode(itemNumber);
  }
};

export const formatItemNumberOption = (item: ITcc) => ({
  value: item,
  label: `${getItemNumberDisplayCode(item)} - ${item?.name}`,
});

export const getItemNumber = (tccs: ITcc[]) => tccs.map(formatItemNumberOption);